/**
 * localStorage Wrapper
 *
 * Handles localStorage access with error handling for
 * environments where localStorage is not available.
 */

const STORAGE_PREFIX = 'shoppex_';

function getKey(key: string): string {
  return `${STORAGE_PREFIX}${key}`;
}

export function getItem<T>(key: string): T | null {
  try {
    const item = localStorage.getItem(getKey(key));
    if (!item) return null;
    return JSON.parse(item) as T;
  } catch {
    return null;
  }
}

export function setItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(getKey(key), JSON.stringify(value));
  } catch {
    console.warn('[shoppex] Failed to save to localStorage');
  }
}

export function removeItem(key: string): void {
  try {
    localStorage.removeItem(getKey(key));
  } catch {
    // Ignore errors
  }
}
